import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Select from "react-select";
import classNames from "classnames";

import { DropdownIndicator, Group, MultiValue, Option } from "./";
import reactSelectActions from "./reactSelectActions";

export class FormMultiDropdown extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.array,
    input: PropTypes.object,
    label: PropTypes.string,
    optionGroupsValues: PropTypes.array,
    placeholder: PropTypes.string
  };

  state = {
    inputValue: "",
    isKeyUsed: false
  };

  getSelectedValues = () => this.props.data.filter(field => this.props.input.value.includes(field.value));

  getGroup = props => <Group onSelectAll={this.handleSelectAll} onUnselectAll={this.handleUnselectAll} isKeyUsed={this.state.isKeyUsed} {...props} />;

  getOption = props => <Option isKeyUsed={this.state.isKeyUsed} {...props} />;

  components = {
    MultiValue,
    DropdownIndicator,
    Group: this.getGroup,
    IndicatorSeparator: null,
    ClearIndicator: null,
    Option: this.getOption
  };

  handleChange = selectedValues => this.props.input.onChange(selectedValues.map(({ value }) => value));

  handleKeyDown = event => {
    if (event.keyCode === 38 || event.keyCode === 40) {
      this.setState({ isKeyUsed: true });
    }

    if (event.keyCode === 13) {
      return event.preventDefault();
    }

    return undefined;
  };

  handleSelectAll = name => {
    const selectedOption = this.props.optionGroupsValues.find(option => option.label === name);
    const selectedOptionValues = selectedOption.options.map(({ value }) => value);
    const currentValues = this.props.input.value;

    this.props.input.onChange(_.uniq([...currentValues, ...selectedOptionValues]));
  };

  handleUnselectAll = name => {
    const selectedOption = this.props.optionGroupsValues.find(option => option.label === name);
    const selectedOptionValues = selectedOption.options.map(({ value }) => value);
    const currentValues = this.props.input.value;

    this.props.input.onChange([...currentValues.filter(value => !selectedOptionValues.includes(value))]);
  };

  handleInputChange = (inputValue, reason = {}) => {
    if (reason.action !== reactSelectActions.setValue) {
      this.setState({ inputValue });
    }

    if (reason.action === reactSelectActions.menuClose) {
      this.setState({ isKeyUsed: false });
    }
  };

  render() {
    return (
      <fieldset className={classNames("input", this.props.className)}>
        <label htmlFor={this.props.input.name} className="input__label">
          {this.props.label}
        </label>

        <div className="input__wrapper">
          <Select
            autosize={false}
            backspaceRemovesValue={false}
            className="input__dropdown"
            closeMenuOnSelect={false}
            components={this.components}
            hideSelectedOptions={false}
            id={this.props.input.name}
            inputValue={this.state.inputValue}
            isMulti
            name={this.props.input.name}
            onBlur={({ value }) => this.props.input.onBlur(value)}
            onChange={this.handleChange}
            onInputChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            options={this.props.optionGroupsValues || this.props.data}
            placeholder={this.props.placeholder}
            tabSelectsValue={false}
            value={this.getSelectedValues()}
            maxMenuHeight="185"
          />
        </div>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/FormMultiDropdown.js